import { useGuild } from '../contexts/GuildContext';
import { useFilters } from '../hooks/useFilters';
import DashboardLayout from '../components/DashboardLayout';
import ServerSelector from '../components/ServerSelector';
import FilterCard from '../components/FilterCard';

export default function FiltersPage() {
  const { selectedGuildId, setSelectedGuildId } = useGuild();
  const { data: filters, isLoading, error } = useFilters(selectedGuildId);

  // 카테고리별로 필터 그룹핑
  const groupedFilters = filters?.reduce((acc, filter) => {
    const category = filter.category || '기타';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(filter);
    return acc;
  }, {} as Record<string, typeof filters>);

  return (
    <DashboardLayout>
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">필터 관리</h1>
              <p className="text-gray-600">스팸, 욕설 등 콘텐츠 필터를 활성화/비활성화하세요</p>
            </div>
            <div className="mt-4 md:mt-0 md:w-80">
              <ServerSelector
                selectedGuildId={selectedGuildId}
                onSelectGuild={setSelectedGuildId}
              />
            </div>
          </div>

          {!selectedGuildId ? (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-yellow-700">서버를 선택해주세요</p>
            </div>
          ) : isLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
          ) : error ? (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-700">필터를 불러올 수 없습니다</p>
            </div>
          ) : (
            <div className="space-y-8">
              {groupedFilters && Object.entries(groupedFilters).map(([category, categoryFilters]) => (
                <div key={category}>
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">{category}</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {categoryFilters.map((filter) => (
                      <FilterCard
                        key={filter.id}
                        filter={filter}
                        guildId={selectedGuildId}
                      />
                    ))}
                  </div>
                </div>
              ))}

              {(!groupedFilters || Object.keys(groupedFilters).length === 0) && (
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
                  <p className="text-gray-600">사용 가능한 필터가 없습니다</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
